import { render, staticRenderFns } from "./AddLessonContentModalV1.vue?vue&type=template&id=c1b7690c&scoped=true"
import script from "./AddLessonContentModalV1.vue?vue&type=script&lang=js"
export * from "./AddLessonContentModalV1.vue?vue&type=script&lang=js"
import style0 from "./AddLessonContentModalV1.vue?vue&type=style&index=0&id=c1b7690c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b7690c",
  null
  
)

export default component.exports